var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeaway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: var(--ion-color-primary);\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.68,33.11c-1.87-2.03-5.04-2.16-7.07-.29l-22.13,20.39.02-13.04c0-3.95-1.52-7.68-4.29-10.5l-24.69-25.17c-2.8-2.86-6.71-4.5-10.71-4.5h-42.06c-4,0-7.77,1.56-10.6,4.39l-25.25,25.23c-2.84,2.83-4.4,6.6-4.4,10.61v12.17l-22.19-19.64c-2.07-1.83-5.23-1.64-7.06.43-1.83,2.07-1.64,5.23.43,7.06l29.24,25.89,8.54,73.6c.88,7.57,7.28,13.27,14.9,13.27h74.83c7.67,0,14.08-5.75,14.91-13.38l7.87-72.34,29.41-27.1c2.03-1.87,2.16-5.03.29-7.06ZM41.97,36.69l25.25-25.23c.94-.94,2.2-1.46,3.53-1.46h42.06c1.33,0,2.64.55,3.57,1.5l24.69,25.17c.92.94,1.43,2.18,1.43,3.5v19.33H40.5v-19.27c0-1.34.52-2.59,1.47-3.54ZM134.17,138.54c-.28,2.54-2.41,4.46-4.97,4.46H54.36c-2.54,0-4.67-1.9-4.97-4.42l-8.02-69.08h100.3l-7.51,69.04Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeaway);
export default __webpack_public_path__ + "static/media/takeaway.57631145e3b5f46eed6ff4184c9666cd.svg";
export { ForwardRef as ReactComponent };